<div
  class="cartridge-widget-container"
  [class.drag-header]="dragActive"
  [class.hidden-title]="widget.hideWidgetTitle"
  (click)="openLink()"
>
  <div class="widget-header">
    <ng-container>
      <h4 class="widget-name">{{ getDisplayName() }}</h4>
      <markant-platform-widget-context-menu
        class="context-menu"
        *ngIf="!dragActive && !widget.isNotRemovable"
        [widgetId]="widget.id"
        [cartridgeId]="widget.cartridgeId"
        (widgetRemoved)="removeWidget(widget)"
      >
      </markant-platform-widget-context-menu>
    </ng-container>
    <markant-icon
      *ngIf="dragActive"
      class="move-icon"
      icon="m_move"
    ></markant-icon>
  </div>

  <section class="widget-content">
    <markant-platform-cartridge-widget
      *ngIf="widget.widgetType === 'CARTRIDGE'"
      [widget]="widget | cast"
    >
    </markant-platform-cartridge-widget>
    <ng-container #placeholder></ng-container>
  </section>
  @if (isDemo) {
    <markant-platform-widget-demo-chip
      (click)="stopPropagation($event)"
      [variantId]="variantId"
    />
  }
  <markant-platform-widget-alert
    [variantId]="variantId"
    (click)="stopPropagation($event)"
  >
  </markant-platform-widget-alert>
</div>
